import ScrollToTop from 'components/ScrollToTop';
import { type ReactElement, lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { DialogsManager } from '@lingoda/student-frontend/dialogs';
import { trans } from '@lingoda/i18n';
import {
    type RouteConfigComponentProps,
    type RouteConfigExtended,
    currentRoute,
    getRouteConfig,
    renderRoutes,
    resolveDynamicOption,
    useQueryFlagsStore,
} from '@lingoda/router';
import { PopupSystem } from '@lingoda/popups';
import { useBrazeSdk } from '@lingoda/braze-sdk';
import { LangValidationFallback } from '@lingoda/student-frontend/components';
import { DixaMessenger } from '@lingoda/help-center';
import Frame from '../../templates/Frame';
import { MainContexts } from './MainContexts';
import { useLazyLoadSectionTranslations } from './useLazyLoadSectionTranslations';

const NotificationSystem = lazy(() => import('components/NotificationSystem'));

let debug: ReactElement | null = null;

if (__REVIEW_TOOLS__) {
    const DebugBar = lazy(() => import('components/DebugBar'));
    debug = <DebugBar />;
}

type Props = RouteConfigComponentProps;

const Index = ({ route }: Props) => {
    const routeObject = currentRoute(route?.routes as RouteConfigExtended[]);
    const routeConfig = getRouteConfig(routeObject);
    const routeLabel = resolveDynamicOption(routeObject?.label) || '';

    useBrazeSdk();
    useLazyLoadSectionTranslations();
    useQueryFlagsStore();

    return (
        <MainContexts section={routeLabel}>
            <Helmet script={DixaMessenger.initializeNonProdScript()}>
                <title>{trans('main-title-', {}, 'public-meta')}</title>
                <meta name="theme-color" content="#ffffff" />
            </Helmet>
            <ScrollToTop />
            <LangValidationFallback routeLabel={routeLabel}>
                <Frame {...routeConfig}>{renderRoutes(route?.routes)}</Frame>
            </LangValidationFallback>

            {debug}
            {!routeConfig.hideNotifications && (
                <>
                    <NotificationSystem />
                    <PopupSystem />
                </>
            )}
            <DialogsManager />
        </MainContexts>
    );
};

export default Index;
